/**
 * @return: the current time in seconds.
 */
export const now = () => {
    return new Date().getTime() / 1000;
};
//# sourceMappingURL=utils.js.map